/* eslint-disable no-unused-vars */
import { lazy } from 'react';
import CBadges from '../container/B2B/CompanyAdmin/Badges/CBadges';
import CBadgeProgress from '../container/B2B/CompanyAdmin/Badges/CBadgeProgress';
import ThreePlaneDashboard from '../container/B2B/CompanyAdmin/Dashboard/ThreePlaneDashboard';
import { withHub } from '../component/AdminHub/AdminHubLayout';
import { ADMIN_HUBS, HUB_SHAPE } from '../utils/adminHubs';
import AppIssues from '../container/APPIssues/AppIssues';
import PeapInvoice from '../container/Peap/components/Payment/PeapInvoice.jsx';
// import CSurveys from '../container/B2B/CompanyAdmin/Surveys/CSurveys';
import BTBAddNotification from '../container/PushNotification/BTBAddNotification';
import ViewNotification from '../container/ViewNotification';
import PartnerDashboard from '../container/Partnership/Dashboard/dashboard';
import IntroduceList from '../container/Partnership/IntroduceCompany/IntroCompany';
import IntroAddCompany from '../container/Partnership/IntroduceCompany/addCompany';
import EditIntroduce from '../container/B2B/B2BAdmin/Partnership/PartnerIntroduced/editIntroduce';
import PartnerEarning from '../container/Partnership/Earning/earning';
import Integrations from '../container/B2B/CompanyAdmin/Integrations/Integrations';
import ViewPartnerNotification from '../container/Partnership/Notification/Notification';
import PartnerLegals from '../container/Partnership/Legals/legals';
import Breathwork from '../container/ContentManagement/Breathwork/Breathwork';
import AddEditBreathwork from '../container/ContentManagement/Breathwork/AddEditBreathwork';
import Specialist from '../container/Peap/components/Specialist';
import NotFound from '../container/404NotFound';
import PulseSurveyDashboard from '../container/PulseSurvey';
import WellpointsInvoiceDetails from '../container/Peap/B2BWellPoints/InvoiceDetails.jsx';
import GenerateInvoice from '../container/Peap/B2BWellPoints/GenerateInvoice.jsx';
import Mytemplatesviewall from '../container/PulseSurvey/Mytemplatesviewall';
import myTemplatesDrafts from '../container/PulseSurvey/myTemplatesDrafts';

import AddEditPulseSurvey from '../container/PulseSurvey/addSurvey/addSurvey';
import InsightsB2bSurvey from '../container/PulseSurvey/InsightsB2bSurvey';
import PreviewPulseSurveys from '../container/PulseSurvey/preview/preivewPulseSurvey';
import PulseSurvey from '../container/PulseSurvey/pulseSurveyList';
import AppFeedbacks from '../container/AppFeedbacks/AppFeedbacks';
import HealthVideos from '../container/HealthVideos/HealthVideos.js';
import AllHealthVideos from '../container/HealthVideos/AllHealthVideos.js';
import EditHealthVideos from '../container/HealthVideos/EditHealthVideos.js';
import ViewSurveyApproval from '../container/ContentApproval/ViewSurveyApproval';
import UnderMaintenance from '../container/userMaintenance';
import AddEditSelfAssessment from '../container/self-assessment/AddEditSelfAssessment';
import SelfAssessmentDashboard from '../container/self-assessment/selfAssessmentDashboard';
import AllAssessment from '../container/self-assessment/AllAssessments';
import ViewAssessment from '../container/self-assessment/viewAssessement';
import ChallangesDashboard from '../container/B2B/CompanyAdmin/TeamChallanges/ChallangesDashboard';
import AddEditChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditChallanges';
import AddEditRewards from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditRewards';
import ViewAllChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllChallanges';
import ViewAllRewards from '../container/B2B/CompanyAdmin/TeamChallanges/ViewAllRewards';
import AddEditWeeklyChallanges from '../container/B2B/CompanyAdmin/TeamChallanges/AddEditWeeklyChallanges';
import AddEditGuidance from '../container/ContentManagement/Guidance/AddEditGuidance';
import Guidance from '../container/ContentManagement/Guidance/Guidance';
import Challenges from '../container/ChallengesAndTasks/challenges/Challenges.js';
import ViewChallenges from '../container/ChallengesAndTasks/challenges/ViewChallenges.js';
import NewChallenges from '../container/ChallengesAndTasks/challenges/NewChallenges.js';
import AddCustomBenefitsPage from '../container/Benefits/AddCustomBenefits.js';
import PeapManagement from '../container/PeapManagement/index.js';
import B2BPage from '../container/B2B/B2BPage.js';
import PartnersPage from '../container/B2B/B2BAdmin/Partnership/PartnersPage.js';
import BadgesAndWellPointsPage from '../container/B2B/B2BAdmin/Badges/index.js';
import BadgeLayout from '../container/B2B/B2BAdmin/Badges/BadgeLayout.js';
import TestLayout from '../container/TestFeature/TestLayout.js';
import Partners from '../container/TestFeature/Partners.js';
import KidsDashboard from '../container/KidsDashboard';
import EliteGames from '../container/EliteGames/EliteGames.jsx';
import eliteGameRoutes from './eliteGameRoute.js';
import ShoorahHealth from '../container/Health/Health.jsx';
import healthRoutes from './healthRoute.js';
import AddEditCustomPlan from '../container/SuperAdminSalarySacrifice/AddEditCustomPlan.js';
import AddEditHealthScheme from '../container/HealthScheme/AddEditHealthScheme.js';
import peptideRoutes from './peptide.js';
import Peptides from '../container/peptide/peptides.jsx';
import Offerings from '../container/Offerings/Offerings.jsx';
import CreateCustomOffering from '../container/Offerings/CreateCustomOffering.jsx';
import ManageOffering from '../container/Offerings/ManageOffering.jsx';
import ElloOfferUsers from '../container/Offerings/ElloOfferUsers.jsx';
import Achievement from '../container/achievements/Achievement.jsx';
import CreateAchievement from '../container/achievements/createAchievement.jsx';
// import B2BWellPoints from '../container/Peap/components/B2BWellBank';
// import AddPOD from '../container/PodExperts/AddPOD';
const SchoolManagement = lazy(() => import('../container/SchoolManagement/SchoolManagement'));
const SchoolDashboard = lazy(() => import('../container/SchoolManagement/SchoolDashboard'));
const CreateSchool = lazy(() => import('../container/SchoolManagement/CreateSchool'));
const ViewSchool = lazy(() => import('../container/SchoolManagement/ViewSchool'));
const TutorialsPage = lazy(() => import('../container/Tutorials/TutorialsPage'));
const TutorialsEditViewPage = lazy(() => import('../container/Tutorials/TutorialsEditViewPage'));
const AddPOD = lazy(() => import('../container/PodExperts/AddPOD'));
const Login = lazy(() => import('../container/Login'));
const millwallLandingPage = lazy(() =>
  import('../container/partnerLanding/millwallLandingPage.js')
);
const vollyballEngland = lazy(() =>
  import('../container/partnerLanding/vollyballEnglandLandingPage.js')
);
const norwichLandingPage = lazy(() => import('../container/partnerLanding/norwichLandingPage.js'));
const ForgotPassword = lazy(() => import('../container/ForgotPassword'));
const ResetPassword = lazy(() => import('../container/ResetPassword'));
const SetupPassword = lazy(() => import('../container/SetupPassword'));
const ChangePassword = lazy(() => import('../container/ChangePassword'));
/**
 * The legacy super-admin dashboard (Dashboard.js + DashboardContent.js/
 * Section1-8). Kept importable at /dashboard-legacy while the rebuilt
 * five-plane dashboard beds in, so a figure that turns out to be missing can
 * be compared against the old page rather than reconstructed from git.
 * Delete both this and container/Dashboard.js once that comparison is done.
 */
const Dashboard = lazy(() => import('../container/Dashboard'));
const AdminPlaneDashboard = lazy(() => import('../container/AdminDashboard/AdminPlaneDashboard'));
const AdminReports = lazy(() => import('../container/AdminReports/AdminReports'));
const PodExperts = lazy(() => import('../container/PodExperts/PodExpertLists'));
const Notification = lazy(() => import('../container/Notification'));
const SubAdmin = lazy(() => import('../container/SubAdmin/SubAdmin'));
const AddEditSubAdmin = lazy(() => import('../container/SubAdmin/AddEditSubAdmin'));
const UsersList = lazy(() => import('../container/Users/Users'));
const UsersSection = lazy(() => import('../container/Users/UsersSection'));
const UsersDashboard = lazy(() => import('../container/Users/UsersDashboard'));
const DesignSystemGallery = lazy(() => import('../container/DesignSystem/DesignSystemGallery'));

/**
 * The Users section: a dashboard and the list, under one tab row.
 *
 * The list keeps `/users` — the address breadcrumbs, stat cards and deep links
 * across the panel already point at — so only this file knows the section
 * gained a second page.
 */
const Users = () => (
  <UsersSection>
    <UsersList />
  </UsersSection>
);

const UsersDashboardPage = () => (
  <UsersSection>
    <UsersDashboard />
  </UsersSection>
);
const ViewEditUser = lazy(() => import('../container/Users/ViewEditUser'));
const Focus = lazy(() => import('../container/ContentManagement/Focus/Focus'));
const FocusView = lazy(() => import('../container/ContentManagement/Focus/AddEditFocus'));
const AddEditFocus = lazy(() => import('../container/ContentManagement/Focus/AddEditFocus'));
const Meditation = lazy(() => import('../container/ContentManagement/Meditations/Meditations'));
const AddEditMeditation = lazy(() =>
  import('../container/ContentManagement/Meditations/AddEditMeditation')
);
const PushNotification = lazy(() => import('../container/PushNotification/PushNotification'));
const AddPushNotification = lazy(() => import('../container/PushNotification/AddNotification'));
const SuperAdminInstantSupport = lazy(() =>
  import('../container/SuperAdminInstantSupport/index.js')
);
const SuperAdminInstantSupportAddCompany = lazy(() =>
  import('../container/SuperAdminInstantSupport/AddCompany.js')
);
const SuperAdminInstantSupportB2C = lazy(() =>
  import('../container/SuperAdminInstantSupport/b2cInstantSupport.js')
);
// Salary Sacrifice and Health Scheme for Shoorah Admins
const SuperAdminSalarySacrifice = lazy(() =>
  import('../container/SuperAdminSalarySacrifice/index.js')
);
const AdminHealthSchemes = lazy(() => import('../container/HealthScheme/AdminHealthSchemes.js'));
const ContentApproval = lazy(() => import('../container/ContentApproval/ContentApproval'));
const ViewContentApproval = lazy(() => import('../container/ContentApproval/ViewContentApproval'));
const CMS = lazy(() => import('../container/CMS/CMS'));
const AddEditCMS = lazy(() => import('../container/CMS/AddEditCMS'));
const Earning = lazy(() => import('../container/Earning/Earning'));
const Affirmation = lazy(() => import('../container/ContentManagement/Affirmation/Affirmation'));
const AddEditAffirmation = lazy(() =>
  import('../container/ContentManagement/Affirmation/AddEditAffirmation')
);
const Gratitude = lazy(() => import('../container/ContentManagement/Gratitude/Gratitude'));
const AddEditGratitude = lazy(() =>
  import('../container/ContentManagement/Gratitude/AddEditGratitude')
);
const Habits = lazy(() => import('../container/ContentManagement/Habits/Habits'));
const AddEditHabits = lazy(() => import('../container/ContentManagement/Habits/AddEditHabits'));
const BedTimeStories = lazy(() =>
  import('../container/ContentManagement/BedTimeStories/BedTimeStories')
);
const Sounds = lazy(() => import('../container/ContentManagement/Sounds/Sounds'));
const AddEditSounds = lazy(() => import('../container/ContentManagement/Sounds/AddEditSounds'));

const Config = lazy(() => import('../container/Config/Config'));

const TopPicks = lazy(() => import('../container/ContentManagement/TopPicks/TopPicks'));
const AddEditTopPicks = lazy(() =>
  import('../container/ContentManagement/TopPicks/AddEditTopPicks')
);

const Manifestation = lazy(() =>
  import('../container/ContentManagement/Manifestation/Manifestation')
);
const AddEditManifestation = lazy(() =>
  import('../container/ContentManagement/Manifestation/AddEditManifestation')
);
// const Draft = lazy(() => import('../container/Draft/Draft'));
// const ViewDraft = lazy(() => import('../container/Draft/ViewDraft'));
const ShoorahPods = lazy(() => import('../container/ContentManagement/ShoorahPods/ShoorahPods'));
const AddEditShoorhPods = lazy(() =>
  import('../container/ContentManagement/ShoorahPods/AddEditShoorahPods')
);
const B2BDashboard = lazy(() => import('../container/B2B/B2BAdmin/B2BDashboard/BTBDashboard'));
const B2BCompanylist = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/Companylist'));
const AddCompany = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/AddCompany'));
const B2BEarning = lazy(() => import('../container/B2B/B2BAdmin/Earnings/BTBEarning'));
const ViewCompany = lazy(() => import('../container/B2B/B2BAdmin/CompanyList/ViewCompany'));
const MyCompany = lazy(() => import('../container/B2B/CompanyAdmin/MyCompany/MyCompany'));
const CompanyUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/CUser'));
const CompanyReport = lazy(() => import('../container/B2B/CompanyAdmin/Reports/CReports'));
const CompanySolution = lazy(() => import('../container/B2B/CompanyAdmin/Solution/CSolution'));
const AddUser = lazy(() => import('../container/B2B/CompanyAdmin/CUsers/AddUser'));

const PartnerList = lazy(() => import('../container/B2B/B2BAdmin/Partnership/Partners/partner'));
const BadgeUsers = lazy(() => import('../container/B2B/B2BAdmin/Badges/BadgeUsers.js'));
const CompanyEmployees = lazy(() => import('../container/B2B/B2BAdmin/Badges/CompanyEmployees.js'));
const BadgeProgress = lazy(() => import('../container/B2B/B2BAdmin/Badges/BadgeProgress.js'));
const BadgeWinnersList = lazy(() => import('../container/B2B/B2BAdmin/Badges/BadgeWinnersList.js'));
const ActiveBadges = lazy(() => import('../container/B2B/B2BAdmin/Badges/activeBadges.js'));
const AddBadges = lazy(() => import('../container/B2B/B2BAdmin/Badges/addBadges.js'));
const PreviewTask = lazy(() =>
  import('../container/B2B/B2BAdmin/Badges/Components/PreviewTask.js')
);

const PartnerIntroduced = lazy(() =>
  import('../container/B2B/B2BAdmin/Partnership/PartnerIntroduced/partnerIntroduced')
);

const PartnerAdd = lazy(() => import('../container/B2B/B2BAdmin/Partnership/Partners/addPartner'));

const MyAccount = lazy(() => import('../container/Partnership/Account/myaccount'));

// Survey imports
const AddEditSurvey = lazy(() => import('../container/Survey/AddEditSurvey'));
const PreviewSurvey = lazy(() => import('../container/Survey/PreviewSurvey'));
const MySurvey = lazy(() => import('../container/PulseSurvey/MyPulseSurvey'));
const SurveyDashboard = lazy(() => import('../container/Survey/SurveyDashboard'));
const SurveyStatistics = lazy(() => import('../container/Survey/SurveyStatistics'));

// Vision imports
const VisionIdeas = lazy(() => import('../container/ContentManagement/VisionIdeas/VisionIdeas'));
const AddEditVisionIdeas = lazy(() =>
  import('../container/ContentManagement/VisionIdeas/AddEditVisionIdeas')
);
//peap imports
const MySpecialistProfile = lazy(() =>
  import('../container/Peap/mySpecialistProfile/mySpecialistProfile')
);

const PeapDashboard = lazy(() => import('../container/Peap/components/PeapDashboard'));
const Tasks = lazy(() => import('../container/ChallengesAndTasks/tasks/Tasks.js'));
const ViewAllTasks = lazy(() => import('../container/ChallengesAndTasks/tasks/ViewAllTasks.js'));
const CreateTask = lazy(() => import('../container/ChallengesAndTasks/tasks/AddTasks.js'));

// Kids Content Management
const Kids = lazy(() => import('../container/KidsContentManagement/Kids/Kids.js'));
const KidsAffirmation = lazy(() =>
  import('../container/KidsContentManagement/Affirmation/Affirmation.js')
);
// const KidsFocus = lazy(() => import('../container/KidsContentManagement/Focus/Focus.js'));
// const KidsBreathworks = lazy(() => import('../container/KidsContentManagement/Breathworks/Breathworks.js'));
const KidsStories = lazy(() => import('../container/KidsContentManagement/Stories/Stories.js'));
// const KidsAddEditFocus = lazy(() => import('../container/KidsContentManagement/Focus/AddEditFocus.js'));
const KidsAddEditAffirmation = lazy(() =>
  import('../container/KidsContentManagement/Affirmation/AddEditAffirmation.js')
);
const KidsAddEditStories = lazy(() =>
  import('../container/KidsContentManagement/Stories/AddEditStories.js')
);
// const KidsAddEditBreathworks = lazy(() => import('../container/KidsContentManagement/Breathworks/AddEditBreathworks.js'));
const KidsPods = lazy(() => import('../container/KidsContentManagement/Pods/Pods.js'));
const KidsAddEditPods = lazy(() =>
  import('../container/KidsContentManagement/Pods/AddEditPods.js')
);
const KidsView = lazy(() => import('../container/KidsContentManagement/Kids/KidsView.js'));

const MarketPlace = lazy(() => import('../container/MarketPlace/index.js'));
const MarketPlaceNewOffering = lazy(() => import('../container/MarketPlace/CreateNewOffering.js'));
const MarketPlaceViewCompanies = lazy(() => import('../container/MarketPlace/ViewCompanies.js'));
const MarketPlaceViewOffers = lazy(() => import('../container/MarketPlace/ViewOffers.js'));
const MarketPlaceCreateNewCompanyOffer = lazy(() =>
  import('../container/MarketPlace/CreateNewCompanyOffer.js')
);
const Vouchers = lazy(() => import('../container/Vouchers'));
const ViewVoucherOrder = lazy(() => import('../container/Vouchers/ViewVoucherOrder'));

const ElloOfferingsStats = lazy(() => import('../container/Stats/Marketplace/ElloOfferingsStats'));
const EGiftsStats = lazy(() => import('../container/Stats/Marketplace/EGiftsStats'));

const TestLandingPage = lazy(() => import('../container/TestFeature/index.js'));
const CreateTestPage = lazy(() => import('../container/TestFeature/CreateTest.js'));
const ViewTestsPage = lazy(() => import('../container/TestFeature/viewTests.js'));
const TestsB2BCompaniesPage = lazy(() => import('../container/TestFeature/B2bcompaniesTable.js'));
const B2BTestCompaniesTable = lazy(() =>
  import('../container/TestFeature/B2BCompanyTestResults.js')
);

// B2B WellPoints
const B2BWellPoints = lazy(() => import('../container/Peap/B2BWellPoints/B2BWellPoints'));
const SuperAdminTestFeature = lazy(() => import('../container/SuperAdminTestFeature/index.js'));

// Soorah Health imports
const SoorahHealth = lazy(() => import('../container/SoorahHealth'));
const WorkoutListing = lazy(() => import('../container/SoorahHealth/Workout/WorkoutListing'));
const WorkoutDetail = lazy(() => import('../container/SoorahHealth/Workout/WorkoutDetail'));
const AddWorkout = lazy(() => import('../container/SoorahHealth/Workout/AddWorkout'));
const WorkoutPlanListing = lazy(() =>
  import('../container/SoorahHealth/WorkoutPlan/WorkoutPlanListing')
);
const WorkoutPlanDetail = lazy(() =>
  import('../container/SoorahHealth/WorkoutPlan/WorkoutPlanDetail')
);
const AddWorkoutPlan = lazy(() => import('../container/SoorahHealth/WorkoutPlan/AddWorkoutPlan'));
const RecipeListing = lazy(() => import('../container/SoorahHealth/Recipe/RecipeListing'));
const RecipeDetail = lazy(() => import('../container/SoorahHealth/Recipe/RecipeDetail'));
const AddRecipe = lazy(() => import('../container/SoorahHealth/Recipe/AddRecipe'));

const SleepSoundsDashboard = lazy(() => import('../container/SleepHub/SoundsDashboard'));
const SleepTrackerDashboard = lazy(() => import('../container/SleepHub/TrackerDashboard'));
const SleepB2BLogs = lazy(() => import('../container/SleepHub/B2BLogs'));
const SleepCompanyLogs = lazy(() => import('../container/SleepHub/CompanyLogs'));
const SleepB2CLogs = lazy(() => import('../container/SleepHub/B2CLogs'));
const SleepUserDetail = lazy(() => import('../container/SleepHub/SleepUserDetail'));

const withBadgeLayout = (Component) => () =>
  (
    <BadgeLayout>
      <Component />
    </BadgeLayout>
  );

// ---- Super-admin feature hubs ----
// Every hub has the same six routes over the same four page shapes, so they
// are generated from the registry rather than written out nineteen times.
// See utils/adminHubs.js and component/AdminHub/HubPages.jsx.
const hubPage = (load, key) => lazy(() => load().then((m) => ({ default: m[key] })));

const hubRoutes = (hub, load) => {
  const page = (key) => withHub(hub)(hubPage(load, key));
  const route = (path, name, key) => ({
    path,
    exact: true,
    name: `${hub.title} ${name}`,
    component: page(key),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  });

  const shape = hub.shape || HUB_SHAPE.FULL;
  const base = hub.basePath;

  // A company-scoped hub opens on the company list rather than a dashboard:
  // its figures need a company before they mean anything.
  if (shape === HUB_SHAPE.COMPANY) {
    return [
      route(base, 'Companies', 'Companies'),
      route(`${base}/company/:id`, 'Company', 'CompanyDetail'),
      ...(hub.hasUserDetail === false ? [] : [route(`${base}/user`, 'User', 'UserDetail')])
    ];
  }

  return [
    route(base, 'Dashboard', 'Dashboard'),
    ...(hub.extraRoutes || []).map((extra) => route(extra.path, extra.name, extra.key)),
    route(`${base}/b2b`, 'B2B Companies', 'Companies'),
    route(`${base}/b2b/company/:id`, 'Company', 'CompanyDetail'),
    ...(shape === HUB_SHAPE.NO_B2C ? [] : [route(`${base}/b2c`, 'B2C Users', 'B2CUsers')]),
    // A hub with no per-person page (Games, Guided Path, Trigger Trace,
    // Cessation) omits the user routes rather than rendering an empty page.
    ...(hub.hasUserDetail === false
      ? []
      : [
          route(`${base}/b2b/user`, 'User', 'UserDetail'),
          ...(shape === HUB_SHAPE.NO_B2C ? [] : [route(`${base}/b2c/user`, 'User', 'UserDetail')])
        ])
  ];
};

const BreathworkSessionsDashboard = lazy(() =>
  import('../container/BreathworkHub/SessionsDashboard')
);
const BreathworkAudioDashboard = lazy(() => import('../container/BreathworkHub/AudioDashboard'));
const BreathworkB2BLogs = lazy(() => import('../container/BreathworkHub/B2BLogs'));
const BreathworkCompanyLogs = lazy(() => import('../container/BreathworkHub/CompanyLogs'));
const BreathworkB2CLogs = lazy(() => import('../container/BreathworkHub/B2CLogs'));
const BreathworkUserDetail = lazy(() => import('../container/BreathworkHub/BreathworkUserDetail'));

const HabitsTrackerDashboard = lazy(() => import('../container/HabitsHub/TrackerDashboard'));
const HabitsB2BLogs = lazy(() => import('../container/HabitsHub/B2BLogs'));
const HabitsCompanyLogs = lazy(() => import('../container/HabitsHub/CompanyLogs'));
const HabitsB2CLogs = lazy(() => import('../container/HabitsHub/B2CLogs'));
const HabitUserDetail = lazy(() => import('../container/HabitsHub/HabitUserDetail'));

const CompanySleepLayout = lazy(() =>
  import('../container/B2B/CompanyAdmin/Sleep/CompanySleepLayout')
);
const CSleepTracker = lazy(() => import('../container/B2B/CompanyAdmin/Sleep/CSleepTracker'));
const CSleepSounds = lazy(() => import('../container/B2B/CompanyAdmin/Sleep/CSleepSounds'));
const CSleepUsers = lazy(() => import('../container/B2B/CompanyAdmin/Sleep/CSleepUsers'));
const CSleepUserDetail = lazy(() => import('../container/B2B/CompanyAdmin/Sleep/CSleepUserDetail'));

const withCompanySleepLayout = (Component) => () =>
  (
    <CompanySleepLayout>
      <Component />
    </CompanySleepLayout>
  );

const withTestLayout = (Element) => () =>
  (
    <TestLayout>
      <Element />
    </TestLayout>
  );

const routes = [
  {
    path: '/millwall',
    name: 'MillWall Landing',
    component: millwallLandingPage,
    private: false
  },
  {
    path: '/volleyballEngland',
    name: 'Vollyball England',
    component: vollyballEngland,
    private: false
  },
  {
    path: '/norwich',
    name: 'Norwich City Landing',
    component: norwichLandingPage,
    private: false
  },
  {
    path: '/login',

    name: 'Login',
    component: Login,
    private: false
  },
  {
    path: '/forgot-password',

    name: 'ForgotPassword',
    component: ForgotPassword,
    private: false
  },
  {
    path: '/reset-password',

    name: 'ResetPassword',
    component: ResetPassword,
    private: false
  },
  {
    path: '/setup-password',

    name: 'SetupPassword',
    component: SetupPassword,
    private: false
  },
  {
    path: '/change-password',

    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts',

    name: 'Experts',
    component: PodExperts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    // Same component as /podExperts: the card and its header are shared, and
    // only the body below them swaps. See PodExpertLists' `isDashboard`.
    path: '/podExperts/dashboard',

    name: 'Experts Dashboard',
    component: PodExperts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts/addPodExperts',

    name: 'Add Experts',
    component: AddPOD,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/podExperts/editPodExperts/:id',

    name: 'Edit Experts',
    component: AddPOD,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/dashboard',

    name: 'Dashboard',
    component: AdminPlaneDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/dashboard-legacy',

    name: 'Dashboard (legacy)',
    component: Dashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-dashboard',

    name: 'Kids Dashboard',
    component: KidsDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/notifications',

    name: 'Notification',
    // component: Notification,
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sub-admins',

    name: 'SubAdmin',
    component: SubAdmin,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/sub-admins/add-edit',

    name: 'AddEditSubAdmin',
    component: AddEditSubAdmin,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/school-dashboard',

    name: 'SchoolDashboard',
    component: SchoolDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/school-management/create',
    exact: true,
    name: 'CreateSchool',
    component: CreateSchool,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/school-management/:id',
    exact: true,
    name: 'ViewSchool',
    component: ViewSchool,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/school-management',

    name: 'SchoolManagement',
    component: SchoolManagement,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/users',

    name: 'Users',
    component: Users,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/users/dashboard',

    name: 'UsersDashboard',
    component: UsersDashboardPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    // Every shared component on one page. Not linked from the sidebar: it is
    // for whoever is changing a primitive, not for running the platform.
    path: '/design-system',

    name: 'DesignSystem',
    component: DesignSystemGallery,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/users/view',

    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/users/edit',

    name: 'ViewEditUser',
    component: ViewEditUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges',

    name: 'Challenges',
    // component: UnderMaintenance,
    component: Challenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks',

    name: 'Tasks',
    // component: UnderMaintenance,
    component: Tasks,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks/view-all-tasks',

    name: 'Tasks',
    component: ViewAllTasks,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/tasks/create-task',

    name: 'Tasks',
    component: CreateTask,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges/view-challenges',

    name: 'Challenges',
    component: ViewChallenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/challenges/create-new-challenges',

    name: 'Challenges',
    component: NewChallenges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/focus',

    name: 'Focus',
    component: Focus,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/focus/view',

    name: 'Focus-view',
    component: FocusView,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/focus/add-edit',

    name: 'AddEditFocus',
    component: AddEditFocus,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/meditation/manage',

    name: 'Meditation',
    component: Meditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/meditation/manage/add-edit',

    name: 'AddEditMeditation',
    component: AddEditMeditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/meditation/manage/view',

    name: 'ViewAffirmation',
    component: AddEditMeditation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/manage',

    name: 'Breathwork',
    component: Breathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/manage/add-edit',

    name: 'AddEditBreathwork',
    component: AddEditBreathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/manage/view',

    name: 'ViewBreathwork',
    component: AddEditBreathwork,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/guidance',

    name: 'Guidance',
    component: Guidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/guidance/add-edit',

    name: 'AddEditGuidance',
    component: AddEditGuidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/guidance/view',

    name: 'ViewGuidance',
    component: AddEditGuidance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/affirmation',

    name: 'Affirmation',
    component: Affirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/affirmation/add-edit',

    name: 'AddEditAffirmation',
    component: AddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/affirmation/view',

    name: 'AddEditAffirmation',
    component: AddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/gratitude',

    name: 'Gratitude',
    component: Gratitude,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/gratitude/add-edit',

    name: 'AddEditGratitude',
    component: AddEditGratitude,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/manage',

    name: 'Habits',
    component: Habits,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/manage/view',

    name: 'ViewHabits',
    component: AddEditHabits,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/manage/add-edit',

    name: 'AddEditHabits',
    component: AddEditHabits,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/bedtime-stories',

    name: 'BedTimeStories',
    component: BedTimeStories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/manage',

    name: 'Sounds',
    component: Sounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/manage/view',

    name: 'ViewSound',
    component: AddEditSounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/manage/add-edit',

    name: 'Sounds',
    component: AddEditSounds,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/top-picks',

    name: 'TopPicks',
    component: TopPicks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/top-picks/add-edit',

    name: 'TopPicks',
    component: AddEditTopPicks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/manifestation',

    name: 'Manifestation',
    component: Manifestation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/manifestation/add-edit',

    name: 'AddEditManifestation',
    component: AddEditManifestation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-list',

    name: 'Kids',
    component: Kids,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids/view/:id',

    name: 'KidsView',
    component: KidsView,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/kids-pods',

    name: 'KidsPods',
    component: KidsPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/kids-pods/view/:id',

    name: 'KidsPodsView',
    component: KidsAddEditPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/kids-pods/add-edit',

    name: 'KidsPodsAddEdit',
    component: KidsAddEditPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/affirmation',

    name: 'KidsAffirmation',
    component: KidsAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/affirmation/view',

    name: 'KidsAffirmationView',
    component: KidsAddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/affirmation/add-edit',

    name: 'KidsAffirmationAddEdit',
    component: KidsAddEditAffirmation,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/stories',

    name: 'KidsStories',
    component: KidsStories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/stories/view',

    name: 'KidsStoriesView',
    component: KidsAddEditStories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/kids-content-management/stories/add-edit',

    name: 'KidsStoriesAddEdit',
    component: KidsAddEditStories,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  {
    path: '/push-notification',

    name: 'PushNotification',
    component: PushNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/push-notification/add',

    name: 'AddPushNotification',
    component: AddPushNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // Instant Support and its pages

  {
    path: '/instant-support/b2b',

    name: 'InstantSupport',
    component: SuperAdminInstantSupport,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2b/add-company',

    name: 'InstantSupport',
    component: SuperAdminInstantSupportAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2b/add-company',

    name: 'InstantSupport',
    component: SuperAdminInstantSupportAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/instant-support/b2c',

    name: 'InstantSupport',
    component: UnderMaintenance,
    // component: SuperAdminInstantSupportB2C,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Offerings page for Shoorah Admins
  {
    path: '/offering',

    name: 'Offerings',
    component: Offerings,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/offering/create',

    name: 'Create Custom Offering',
    component: CreateCustomOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/offering/manage/:id',

    name: 'Manage Custom Offering',
    component: ManageOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Ello / Gourmet Society offer users
  {
    path: '/ello-offer-users',
    name: 'Ello Offer Users',
    component: ElloOfferUsers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Salary Sacrifice routes for Shoorah Admins
  {
    path: '/salary-sacrifice',

    name: 'SalarySacrifice',
    component: SuperAdminSalarySacrifice,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/salary-sacrifice/create',

    name: 'SalarySacrifice',
    component: AddEditCustomPlan,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Health Scheme routes for Shoorah Admins
  {
    path: '/health-scheme',

    name: 'HealthScheme',
    component: AdminHealthSchemes,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/health-scheme/create',

    name: 'HealthScheme',
    component: AddEditHealthScheme,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/achievements',

    name: 'achievements',
    component: Achievement,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/achievements/create',

    name: 'Create Achievement',
    component: CreateAchievement,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/offering/create',

    name: 'Create Custom Offering',
    component: CreateCustomOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  // Test Feature pages and their routes
  // {
  //   path: '/test/b2c',
  //   exact: true,
  //   name: 'Shoorah Test',
  //   component: TestLandingPage,
  //   private: true,
  //   onlyCompanyAdmin: false,
  //   onlyAdmin: true
  // },
  // MarketPlace pages and their routes
  {
    path: '/marketplace',

    name: 'Marketplace',
    component: MarketPlace,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-offering',

    name: 'Marketplace New Offering',
    component: MarketPlaceNewOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-companies',

    name: 'Marketplace View Companies',
    component: MarketPlaceViewCompanies,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-offers',

    name: 'Marketplace View Offers',
    component: MarketPlaceViewOffers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-company-offer',

    name: 'Marketplace Create New Company',
    component: MarketPlaceCreateNewCompanyOffer,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/stats/marketplace/ello',
    name: 'Ello Offerings Stats',
    component: ElloOfferingsStats,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/stats/marketplace/egifts',
    name: 'E-Gifts Stats',
    component: EGiftsStats,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/vouchers',

    name: 'Vouchers',
    component: Vouchers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/vouchers/:orderId',

    name: 'View Voucher Order',
    component: ViewVoucherOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/tests-dashboard/create-test',

    name: 'Create Test',
    // component: UnderMaintenance,
    // component: CreateTestPage,
    component: withTestLayout(CreateTestPage),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/tests-dashboard',

    name: 'View Tests',
    // component: UnderMaintenance,
    // component: ViewTestsPage,
    // component: ShoorahTest,
    component: withTestLayout(ViewTestsPage),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/b2b',

    name: 'B2B Companies Tests',
    // component: UnderMaintenance,
    // component: TestsB2BCompaniesPage,
    component: withTestLayout(TestsB2BCompaniesPage),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/b2b/b2b-company',

    name: 'B2B Company Test Results',
    // component: UnderMaintenance,
    // component: B2BTestCompaniesTable,
    component: withTestLayout(B2BTestCompaniesTable),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/b2c',
    exact: true,
    name: 'Shoorah Test',
    // component: TestLandingPage,
    component: withTestLayout(TestLandingPage),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/test/partners',
    exact: true,
    name: 'API Partners Management',
    component: withTestLayout(Partners),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // MarketPlace pages and their routes
  {
    path: '/marketplace',

    name: 'Marketplace',
    component: MarketPlace,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-offering',

    name: 'Marketplace New Offering',
    component: MarketPlaceNewOffering,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-companies',

    name: 'Marketplace View Companies',
    component: MarketPlaceViewCompanies,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/view-offers',

    name: 'Marketplace View Offers',
    component: MarketPlaceViewOffers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/marketplace/create-new-company-offer',

    name: 'Marketplace Create New Company',
    component: MarketPlaceCreateNewCompanyOffer,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/stats/marketplace/ello',
    name: 'Ello Offerings Stats',
    component: ElloOfferingsStats,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/stats/marketplace/egifts',
    name: 'E-Gifts Stats',
    component: EGiftsStats,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/vouchers',

    name: 'Vouchers',
    component: Vouchers,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/vouchers/:orderId',

    name: 'View Voucher Order',
    component: ViewVoucherOrder,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/content-approval',

    name: 'ContentApproval',
    component: ContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/content-approval/view',

    name: 'view-content-approval',
    component: ViewContentApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/view-survey/:surveyId',

    name: 'view-view-survey',
    component: ViewSurveyApproval,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/cms',

    name: 'cms',
    component: CMS,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/cms/edit-view',

    name: 'AddEditCMS',
    component: AddEditCMS,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/earning',

    name: 'Earning',
    component: Earning,
    private: true,
    onlyCompanyAdmin: false
  },
  {
    path: '/config',

    name: 'config',
    component: Config,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // {
  //   path: '/draft',
  //
  //   name: 'draft',
  //   component: Draft,
  //   private: true,
  // onlyCompanyAdmin:false,
  //   onlyAdmin: false,
  // },
  // {
  //   path: '/draft/view',
  //
  //   name: 'ViewDraft',
  //   component: ViewDraft,
  //   private: true,
  // onlyCompanyAdmin:false,
  //   onlyAdmin: false,
  // },
  {
    path: '/shoorah-pods/manage',

    name: 'ShoorahPods',
    component: ShoorahPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/shoorah-pods/manage/view',

    name: 'ViewShoorahPods',
    component: AddEditShoorhPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/app-issues',

    name: 'appIssues',
    component: AppIssues,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/app-feedbacks',

    name: 'appFeedbacks',
    component: AppFeedbacks,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/benefits',
    exact: true,
    name: 'Benefits',
    component: UnderMaintenance,
    // component: AdminBenefits,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '//benefits/add-custom-benefits',
    exact: true,
    name: 'Add Custom Benefits',
    component: AddCustomBenefitsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos',

    name: 'healthVideos',
    component: HealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos/all',

    name: 'allHealthVideos',
    component: AllHealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/health-videos/add-edit',

    name: 'addHealthVideos',
    component: EditHealthVideos,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/shoorah-pods/manage/add-edit',

    name: 'AddEditShoorahPods',
    component: AddEditShoorhPods,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/reports',
    exact: true,
    name: 'Reports',
    component: AdminReports,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  ...hubRoutes(ADMIN_HUBS.meditation, () => import('../container/AdminHubs/meditation')),
  ...hubRoutes(ADMIN_HUBS.shoorahVids, () => import('../container/AdminHubs/shoorahVids')),
  ...hubRoutes(ADMIN_HUBS.visionBoard, () => import('../container/AdminHubs/visionBoard')),
  ...hubRoutes(ADMIN_HUBS.selfAssessment, () => import('../container/AdminHubs/selfAssessment')),
  ...hubRoutes(ADMIN_HUBS.shoorahPods, () => import('../container/AdminHubs/shoorahPods')),
  ...hubRoutes(ADMIN_HUBS.shuru, () => import('../container/AdminHubs/shuru')),
  ...hubRoutes(ADMIN_HUBS.mood, () => import('../container/AdminHubs/mood')),
  ...hubRoutes(ADMIN_HUBS.homeTesting, () => import('../container/AdminHubs/homeTesting')),
  ...hubRoutes(ADMIN_HUBS.eliteMind, () => import('../container/AdminHubs/eliteMind')),
  ...hubRoutes(ADMIN_HUBS.moneyMind, () => import('../container/AdminHubs/moneyMind')),
  ...hubRoutes(ADMIN_HUBS.scans, () => import('../container/AdminHubs/scans')),
  ...hubRoutes(ADMIN_HUBS.games, () => import('../container/AdminHubs/games')),
  ...hubRoutes(ADMIN_HUBS.guidedPath, () => import('../container/AdminHubs/guidedPath')),
  ...hubRoutes(ADMIN_HUBS.triggerTrace, () => import('../container/AdminHubs/triggerTrace')),
  ...hubRoutes(ADMIN_HUBS.selfDevelopment, () => import('../container/AdminHubs/selfDevelopment')),
  ...hubRoutes(ADMIN_HUBS.cessation, () => import('../container/AdminHubs/cessation')),
  ...hubRoutes(ADMIN_HUBS.marketplace, () => import('../container/AdminHubs/marketplace')),
  ...hubRoutes(ADMIN_HUBS.perks, () => import('../container/AdminHubs/perks')),
  ...hubRoutes(ADMIN_HUBS.challenges, () => import('../container/AdminHubs/challenges')),
  {
    path: '/sleep',
    exact: true,
    name: 'Sleep Sounds Dashboard',
    component: withHub(ADMIN_HUBS.sleep)(SleepSoundsDashboard),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/tracker',
    exact: true,
    name: 'Sleep Tracker Dashboard',
    component: withHub(ADMIN_HUBS.sleep)(SleepTrackerDashboard),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/b2b',
    exact: true,
    name: 'Sleep B2B Logs',
    component: withHub(ADMIN_HUBS.sleep)(SleepB2BLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/b2b/company/:id',
    exact: true,
    name: 'Sleep Company Logs',
    component: withHub(ADMIN_HUBS.sleep)(SleepCompanyLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/b2b/user',
    exact: true,
    name: 'Sleep User Detail',
    component: withHub(ADMIN_HUBS.sleep)(SleepUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/b2c',
    exact: true,
    name: 'Sleep B2C Logs',
    component: withHub(ADMIN_HUBS.sleep)(SleepB2CLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/sleep/b2c/user',
    exact: true,
    name: 'Sleep User Detail',
    component: withHub(ADMIN_HUBS.sleep)(SleepUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork',
    exact: true,
    name: 'Breathwork Sessions Dashboard',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkSessionsDashboard),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/audio',
    exact: true,
    name: 'Breathwork Audio Dashboard',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkAudioDashboard),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/b2b',
    exact: true,
    name: 'Breathwork B2B Logs',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkB2BLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/b2b/company/:id',
    exact: true,
    name: 'Breathwork Company Logs',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkCompanyLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/b2b/user',
    exact: true,
    name: 'Breathwork User Detail',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/b2c',
    exact: true,
    name: 'Breathwork B2C Logs',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkB2CLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/breathwork/b2c/user',
    exact: true,
    name: 'Breathwork User Detail',
    component: withHub(ADMIN_HUBS.breathwork)(BreathworkUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker',
    exact: true,
    name: 'Habit Tracker Dashboard',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitsTrackerDashboard),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/b2b',
    exact: true,
    name: 'Habit Tracker B2B Logs',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitsB2BLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/b2b/company/:id',
    exact: true,
    name: 'Habit Tracker Company Logs',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitsCompanyLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/b2b/user',
    exact: true,
    name: 'Habit Tracker User Detail',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/b2c',
    exact: true,
    name: 'Habit Tracker B2C Logs',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitsB2CLogs),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/habit-tracker/b2c/user',
    exact: true,
    name: 'Habit Tracker User Detail',
    component: withHub(ADMIN_HUBS.habitTracker)(HabitUserDetail),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges',
    exact: true,
    name: 'Badges',
    component: withBadgeLayout(BadgesAndWellPointsPage),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/active-badges',
    exact: true,
    name: 'Active Badges',
    component: withBadgeLayout(ActiveBadges),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/active-badges/winners',
    exact: true,
    name: 'Badge Winners',
    component: withBadgeLayout(BadgeWinnersList),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/active-badges/add-badge',
    exact: true,
    name: 'Add Badge',
    component: withBadgeLayout(AddBadges),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/active-badges/preview',
    exact: true,
    name: 'Preview Badge',
    component: withBadgeLayout(PreviewTask),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/users',
    exact: true,
    name: 'Badge Users',
    component: withBadgeLayout(BadgeUsers),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/users/company/:id',
    exact: true,
    name: 'Company Employees',
    component: withBadgeLayout(CompanyEmployees),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/badges/users/progress',
    exact: true,
    name: 'Badge Progress',
    component: withBadgeLayout(BadgeProgress),
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners',

    name: 'Partner-list',
    // component: PartnerList,
    component: PartnersPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-introduced',

    name: 'Partners-company-introduced',
    component: PartnerIntroduced,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners-introduce/edit-introduce',

    name: 'Edit-company-introduced',
    component: EditIntroduce,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partners/add-partner',

    name: 'Partners-add-partner',
    component: PartnerAdd,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-earning',

    name: 'Partner Earning',
    component: PartnerEarning,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-notification',

    name: 'Partner Notifications',
    component: ViewPartnerNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-dashboard',

    name: 'B2BDashboard',
    // component: B2BDashboard,
    component: B2BPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list',

    name: 'B2BCompanylist',
    component: B2BCompanylist,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-earning',

    name: 'B2BEarning',
    component: B2BEarning,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list/addCompany',

    name: 'AddCompany',
    component: AddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/B2B-company-list/viewCompany',

    name: 'ViewCompany',
    component: ViewCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/partner-dashboard',

    name: 'PartnerDashboard',
    // TODO: Switch
    // component: CompanyDashboard,
    component: PartnerDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/partner-account',

    name: 'PartnerAccount',
    // TODO: Switch
    // component: CompanyDashboard,
    component: MyAccount,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/introduce',

    name: 'IntroduceCompany',
    // TODO: Switch
    // component: CompanyDashboard,
    component: IntroduceList,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/introduce/add-company',

    name: 'IntroduceAddCompany',
    // TODO: Switch
    // component: CompanyDashboard,
    component: IntroAddCompany,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    path: '/partner-legals',

    name: 'Legals',
    // TODO: Switch
    // component: CompanyDashboard,
    component: PartnerLegals,
    private: true,
    onlyCompanyAdmin: false,
    onlyPartner: true,
    onlyAdmin: false
  },
  {
    // The rebuilt three-plane dashboard is now the company dashboard.
    // NewCDashboard survives only inside the super admin's View Company tab.
    path: '/:slug/dashboard',

    name: 'CompanyDashboard',
    component: ThreePlaneDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/myCompany',

    name: 'MyCompany',
    component: MyCompany,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sleep',
    exact: true,
    name: 'CompanySleepTracker',
    component: withCompanySleepLayout(CSleepTracker),
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sleep/sounds',
    exact: true,
    name: 'CompanySleepSounds',
    component: withCompanySleepLayout(CSleepSounds),
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sleep/users',
    exact: true,
    name: 'CompanySleepUsers',
    component: withCompanySleepLayout(CSleepUsers),
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sleep/user',
    exact: true,
    name: 'CompanySleepUserDetail',
    component: withCompanySleepLayout(CSleepUserDetail),
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/notification',

    name: 'CompanyNotification',
    component: Notification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/notification/add',

    name: 'BTBAddPushNotification',
    component: BTBAddNotification,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/:slug/report',

    name: 'CompanyReport',
    component: CompanyReport,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/badges',

    name: 'CompanyReport',
    component: CBadges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/badges/progress',

    name: 'CompanyBadgeProgress',
    component: CBadgeProgress,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/team-challanges',

    name: 'TeamChallanges',
    component: ChallangesDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/view-all-rewards',

    name: 'TeamChallanges',
    component: ViewAllRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/view-all-challenges',

    name: 'TeamChallanges',
    component: ViewAllChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-challenges',

    name: 'TeamChallanges',
    component: AddEditChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-weekly-challenges',

    name: 'TeamChallanges',
    component: AddEditWeeklyChallanges,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/team-challanges/add-edit-rewards',

    name: 'TeamChallanges',
    component: AddEditRewards,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: true
  },
  {
    path: '/:slug/integrations',

    name: 'Integrations',
    component: Integrations,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/solution',

    name: 'CompanySolution',
    component: CompanySolution,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/users',

    name: 'CompanyUser',
    component: CompanyUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/adduser',

    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/edituser',

    name: 'AddUser',
    component: AddUser,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/notifications',

    name: 'Notification',
    component: Notification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/notifications/view',

    name: 'Notification',
    component: ViewNotification,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/change-password',

    name: 'ChangePassword',
    component: ChangePassword,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },

  {
    path: '/:slug/sub-admins',

    name: 'SubAdmin',
    component: SubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/:slug/sub-admins/add-edit',

    name: 'AddEditSubAdmin',
    component: AddEditSubAdmin,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // Survey Routes Starts From Here
  {
    path: '/surveys/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys',

    name: 'Survey Dashboard',
    component: SurveyDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys',

    name: 'Survey Dashboard',
    component: SurveyDashboard,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/summary/:surveyId',
    exact: false,
    name: 'Survey Summary',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/summary/:surveyId',
    exact: false,
    name: 'Survey Summary',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/add-edit',
    exact: false,
    name: 'Survey Add Edit',
    component: AddEditSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/add-edit',

    name: 'Survey Add Edit',
    component: AddEditSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/surveys/preview',
    exact: false,
    name: 'Survey Preview',
    component: PreviewSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/:slug/surveys/preview',
    exact: false,
    name: 'Survey Preview',
    component: PreviewSurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  // Survey Routes Ends
  // Vision Ideas
  {
    path: '/vision-board/manage',

    name: 'VisionIdeas',
    component: VisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/vision-board/manage/view',

    name: 'ViewVisionIdeas',
    component: AddEditVisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/vision-board/manage/add-edit',

    name: 'AddEditVisionIdeas',
    component: AddEditVisionIdeas,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/peap-management',

    name: 'specialistList',
    // component: UnderMaintenance,
    component: Specialist,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-management/invoice/:id',

    name: 'Peap Invoice',
    // component: UnderMaintenance,
    component: PeapInvoice,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-dashboard',
    exact: true,
    name: 'Dashboard',
    //  component: UnderMaintenance,
    // component: PeapDashboard,
    component: PeapManagement,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: '/peap-B2B-wellPoints',
    exact: true,
    name: 'B2B WellPoints',
    component: UnderMaintenance,
    // component: B2BWellPoints,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-B2B-wellPoints/view/:id',

    name: 'Invoice Details',
    component: WellpointsInvoiceDetails,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-B2B-wellPoints/generate/invoice/:id',

    name: 'Invoice Details',
    component: GenerateInvoice,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/peap-management/profile/:userId',

    name: 'peap-profile',
    component: MySpecialistProfile,
    // component: UnderMaintenance,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey',

    name: 'pulse survey',
    component: PulseSurveyDashboard,
    // component: UnderMaintenance,

    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/Mytemplatesviewall',

    name: 'Mytemplatesviewall',
    component: Mytemplatesviewall,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/my-survey',
    exact: false,
    name: 'MySurvey',
    component: MySurvey,
    private: true,
    onlyCompanyAdmin: true,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/myTemplatesDrafts',

    name: 'myTemplatesDrafts',
    component: myTemplatesDrafts,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },

  {
    path: '/survey',

    name: 'survey',
    component: SurveyStatistics,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/pulse-survey/add-edit-survey',

    name: 'addEditSurvey',
    component: AddEditPulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  // shoorah admin can see this InsightsB2bSurvey, not in any use right now
  {
    path: '/pulse-survey/add-edit-survey/InsightsB2bSurvey',

    name: 'InsightsB2bSurvey',
    component: InsightsB2bSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  },
  {
    path: '/preview/pulse-surveys',
    exact: false,
    name: 'Pulse Survey Preview',
    component: PreviewPulseSurveys,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  {
    path: '/survey-list',
    exact: false,
    name: 'MySurveyList',
    component: PulseSurvey,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    // The BUILDER's overview — authoring the questionnaires. It used to sit at
    // /self-assessment; that path now belongs to the hub that reports on the
    // answers, so this moved under the hub's content pages like every other
    // feature's library did.
    path: '/self-assessment/manage/overview',
    exact: false,
    name: 'selfAssessmentDashboard',
    component: SelfAssessmentDashboard,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/manage/create',
    exact: false,
    name: 'createSelfAssessment',
    component: AddEditSelfAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/manage',
    exact: false,
    name: 'viewAllSelfAssessment',
    component: AllAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/self-assessment/manage/view',
    exact: false,
    name: 'viewSingleSelfAssessment',
    component: ViewAssessment,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials/new',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsEditViewPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },
  {
    path: '/tutorials/:tutorialId',
    exact: false,
    name: 'tutorials',
    // component: UnderMaintenance,
    component: TutorialsEditViewPage,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true
  },

  // Elite Games Parent Route
  {
    path: '/game/*',
    name: 'EliteGames',
    component: EliteGames,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true,
    children: eliteGameRoutes
  },
  {
    path: '/health/*',
    name: 'ShoorahHealth',
    component: ShoorahHealth,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true,
    children: healthRoutes
  },
  {
    path: '/peptides/*',
    name: 'peptide',
    component: Peptides,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: true,
    children: peptideRoutes
  },

  // QuizZone Routes
  // QuizZone Main Category
  {
    path: '*',

    name: 'not-found',
    component: NotFound,
    private: true,
    onlyCompanyAdmin: false,
    onlyAdmin: false
  }
];
export default routes;
